import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';
import { useNavigate } from 'react-router-dom';
import { MoreVert } from "@mui/icons-material";
import { useContext } from 'react';
import axiosInstance from '../../config';
import SocialContext from '../../context/SocialContext';

export default function FadeMenu({ postID, currentuserID, setfetchagain ,cloudinaryID}) {
    const { setshowalert,setalertmessage } = useContext(SocialContext);
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };


    // ------------ FOR DELETE A POST ----------------
    const deletePostfun = async () => {
        try {
            await axiosInstance.delete(`/api/posts/${postID}`, { data: { userId: currentuserID,cloudinaryID:cloudinaryID } });
            setshowalert(true);
            setfetchagain(true);
            setalertmessage("You have deleted post");
            setTimeout(() => {
                setshowalert(false);
            }, 2000);
        } catch (error) {
            console.log("inside delete a post", error);
        }
    }

    return (
        <div>
            <Button
                id="fade-button"
                aria-controls={open ? 'fade-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                size="small"
            >
                <MoreVert />
            </Button>
            <Menu
                id="fade-menu"
                MenuListProps={{
                    'aria-labelledby': 'fade-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                TransitionComponent={Fade}
            >
                <MenuItem onClick={deletePostfun}>Delete Post</MenuItem>
            </Menu>
        </div>
    );
}
